'use client'

import './PartnersFastMarquee.scss'

import { uuid4 } from '@sentry/utils'
import cn from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import Marquee from 'react-fast-marquee'

import useScrollable from '@/src/entities/application/hooks/useScrollable'
import { IPartner } from '@/src/entities/partner/model'

export type IPartnersFastMarquee = {
  className?: string
  partners: IPartner[]
  isScrollable?: boolean
}

const PartnersFastMarquee = ({
  className,
  partners = [],
  isScrollable = false,
}: IPartnersFastMarquee) => {
  const { scrollContainerRef, scrollableGallery } = useScrollable(partners, isScrollable)

  return (
    <section
      ref={isScrollable ? scrollContainerRef : null}
      className={cn('partners-fast-marquee', {
        [`${className}`]: !!className,
        scrollable: isScrollable,
      })}
    >
      <Marquee
        pauseOnHover
        autoFill
        loop={0}
        style={{ whiteSpace: 'nowrap', animationPlayState: 'var(--pause, running)' }}
      >
        <div className="partners-fast-marquee__grid">
          {scrollableGallery.map((partner, index) => (
            <div
              key={`cell-${partner?.id || index}-${uuid4()}`}
              className="partners-fast-marquee__cell"
            >
              <Link
                href={partner?.link ?? '/'}
                target="_blank"
                className="partners-fast-marquee__image"
              >
                {!!partner?.image && (
                  <Image
                    priority
                    width={110}
                    height={61}
                    src={partner?.image}
                    alt={partner?.title ?? ''}
                  />
                )}
              </Link>
            </div>
          ))}
        </div>
      </Marquee>
    </section>
  )
}

export default PartnersFastMarquee
